type Post = {
  type: string;
  status: string;
};

export function filterPost({
  post,
  filters,
}: {
  post: Post | null;
  filters: string[];
}): Post | null {
  let result = post;
  if (post && filters) {
    filters.forEach((filter) => {
      Object.keys(filter).forEach((key) => {
        if (post[key] !== filter[key]) result = null;
      });
    });
  }
  return result;
}
